
export const getStatusColor = (status: string) => {
  switch (status) {
    case 'active': return 'bg-green-100 text-green-800';
    case 'draft': return 'bg-yellow-100 text-yellow-800';
    case 'expired': return 'bg-red-100 text-red-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export const getTypeColor = (type: string) => {
  return type === 'b2b' ? 'bg-blue-100 text-blue-800' : 'bg-purple-100 text-purple-800';
};

export const getPaymentStatusColor = (status: string) => {
  switch (status) {
    case 'paid': return 'bg-teal-100 text-teal-800';
    case 'pending': return 'bg-orange-100 text-orange-800';
    case 'unpaid': return 'bg-pink-100 text-pink-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};
